import React from 'react';
import { Chip, TableCell, TableRow } from '@mui/material';

import { urls } from '@/urls';
import BatchRunTable from './batch-run-table';

export interface AiAnalysisRun {
  id: number;
  subscription_id: string;
  status: string;
  model: string | null;
  findings_count: number | null;
  inserted_count: number | null;
  skipped_count: number | null;
  error: string | null;
  duration_ms: number | null;
  started_at: string;
}

export const OPTIMIZATION_STATUS_COLORS: Record<
  string,
  'success' | 'error' | 'info' | 'default'
> = {
  Completed: 'success',
  Failed: 'error',
  Running: 'info',
  Skipped: 'default',
  completed: 'success',
  failed: 'error',
  running: 'info',
};

interface OptimizationRunsTableProps {
  triggerFilter: 'manual' | 'cron';
  title: string;
  testId: string;
}

export function OptimizationRunsTable({
  triggerFilter,
  title,
  testId,
}: OptimizationRunsTableProps) {
  return (
    <BatchRunTable
      listUrl={urls.DevOps.aiEngineBatchRuns}
      detailUrl={urls.DevOps.aiEngineBatchRun}
      title={title}
      testId={testId}
      triggerFilter={triggerFilter}
      statusColors={OPTIMIZATION_STATUS_COLORS}
      renderChildHeader={() => (
        <TableRow>
          <TableCell>Subscription</TableCell>
          <TableCell>Status</TableCell>
          <TableCell>Model</TableCell>
          <TableCell align="right">Findings</TableCell>
          <TableCell align="right">Inserted</TableCell>
          <TableCell align="right">Duration</TableCell>
        </TableRow>
      )}
      renderChildRow={(child: AiAnalysisRun) => (
        <TableRow key={child.id}>
          <TableCell>{child.subscription_id}</TableCell>
          <TableCell>
            <Chip
              size="small"
              label={child.status}
              color={OPTIMIZATION_STATUS_COLORS[child.status] ?? 'default'}
              title={child.error ?? undefined}
            />
          </TableCell>
          <TableCell>{child.model}</TableCell>
          <TableCell align="right">{child.findings_count ?? '—'}</TableCell>
          <TableCell align="right">{child.inserted_count ?? '—'}</TableCell>
          <TableCell align="right">
            {child.duration_ms != null
              ? `${Math.round(child.duration_ms / 1000)}s`
              : '—'}
          </TableCell>
        </TableRow>
      )}
      getChildren={(detail) =>
        (detail as { children?: AiAnalysisRun[] }).children ?? []
      }
    />
  );
}
